<template>
  <div class="admin-translate">
    <header-title title="Traducciones Cartas"></header-title>
    <v-row align="start">
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-text-field
          outlined
          dense
          label="Buscar"
          v-model="search"
          class="select-box ml-2"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <v-container fluid>
      <template>
        <div v-for="carta in paginatedData" :key="carta.id">
          <Translate
            :data="carta"
            @saveToCollection="saveToMenusCollection"
          ></Translate>
        </div>
        <div class="text-center">
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(filteredCartas.length / size)"
            circle
            @input="nextPage"
            :total-visible="6"
            color="black"
          ></v-pagination>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import Loader from "../../../components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import Translate from "@/components/admin/translate/Translate";
import { menusCollection, updateMenu } from "@/collections/menus";
import { updateUiMenuOrder } from "@/collections/uiMenuOrder";
export default {
  name: "TranslateCartas",
  components: {
    HeaderTitle,
    Loader,
    Translate
  },
  data() {
    return {
      dialogLoader: false,
      search: "",
      menusCollection: [],
      pageNumber: 1,
      size: 2
    };
  },
  firestore() {
    return {
      menusCollection: menusCollection
    };
  },
  mounted() {
    setTimeout(() => {
      this.dialogLoader = false;
    }, 1000);
  },
  computed: {
    filteredCartas() {
      let _cartas = [...this.menusCollection];

      return this.search
        ? _cartas.filter(carta =>
            carta?.name?.toLowerCase().includes(this.search?.toLowerCase())
          )
        : _cartas;
    },
    paginatedData() {
      let start = this.pageNumber * this.size - this.size;
      let end = start + this.size;
      return this.filteredCartas.slice(start, end);
    }
  },
  methods: {
    nextPage(page) {
      this.pageNumber = page;
    },
    async saveToMenusCollection(input) {
      try {
        await updateMenu(input.id, input);
        await updateUiMenuOrder(input.id, input);
        this.showSuccessMessage("Traducciones Cartas actualizado");
      } catch (error) {
        this.setlogError(
          "update_ui_menu_order/update_menu",
          "Obtained error message in saveToMenusCollection()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>
